import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import FacilitiesListItem from './FacilitiesListItem';
import FacilitiesListEmpty from './FacilitiesListEmpty';

const FacilitiesList = ({ facilities }) => (
  <Fragment>
    {facilities.length === 0 ? (
      <FacilitiesListEmpty />
    ) : (
      facilities.map(item => (
        <FacilitiesListItem
          key={item.ID}
          facility={item}
          onlyFacility={facilities.length === 1}
        />
      ))
    )}
  </Fragment>
);

FacilitiesList.propTypes = {
  facilities: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
};

export default FacilitiesList;



// WEBPACK FOOTER //
// ./src/components/settings/FacilitiesList/FacilitiesList.js